export function dateTimeStringToTimeFormat(dateString: string): string {
    return (dateString || '').replace(
        /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/,
        '$1-$2-$3T$4:$5:$6Z'
    );
}